import type { TimeRange} from "@@/shared/date-time/time-range";
import { timeRangeZodSchema } from "@@/shared/date-time/time-range";

import type { OrderGroupId } from "@@/shared/order-groups/order-group-id";
import type { UserId} from "@@/shared/users/user-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { z } from "zod";
import type { OrderId } from "../order-id";
import type {
    OrderItemId} from "../order-items/order-item-id";
import {
    orderItemIdZodSchema,
} from "../order-items/order-item-id";
import {
    _orderStatusBaseFactory,
    _orderStatusBaseZodSchema,
} from "./_order-status-base";

/** @deprecated */
const orderStatusBookableTimeChangeZodSchema = _orderStatusBaseZodSchema.merge(
    z.object({
        type: z.literal("BOOKABLE_TIME_CHANGE"),
        changedBy: userIdZodSchema,
        from: timeRangeZodSchema,
        to: timeRangeZodSchema,
        orderItemId: orderItemIdZodSchema,
    }),
);

/** @deprecated */
type OrderBookableTimeChange = z.infer<
    typeof orderStatusBookableTimeChangeZodSchema
>;

/** @deprecated */
const orderStatusBookableTimeChangeFactory = (params: {
    readonly orderId: OrderId;
    readonly orderGroupId: OrderGroupId;
    readonly from: TimeRange;
    readonly to: TimeRange;
    readonly orderItemId: OrderItemId;
    readonly changedBy: UserId;
}): OrderBookableTimeChange => ({
    ..._orderStatusBaseFactory(params.orderId, params.orderGroupId),
    type: "BOOKABLE_TIME_CHANGE",
    changedBy: params.changedBy,
    from: params.from,
    to: params.to,
    orderItemId: params.orderItemId,
});

export {
    orderStatusBookableTimeChangeFactory,
    orderStatusBookableTimeChangeZodSchema,
};
export type { OrderBookableTimeChange };
